import { useState, useEffect, useCallback } from 'react';
import { LILAPE_JETTON_ADDRESS, LILAPE_DECIMALS } from '../config';

export const useLilapeBalance = (walletAddress) => {
    const [balance, setBalance] = useState(null);
    const [balanceRaw, setBalanceRaw] = useState(null); // Raw balance in nano units
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const fetchBalance = useCallback(async () => {
        if (!walletAddress) { setBalance(null); setBalanceRaw(null); return; }

        setLoading(true);
        try {
            // tonapi.io — free, no key needed for basic queries
            const res = await fetch(
                `https://tonapi.io/v2/accounts/${encodeURIComponent(walletAddress)}/jettons/${encodeURIComponent(LILAPE_JETTON_ADDRESS)}`,
                { headers: { Accept: 'application/json' } }
            );
            if (!res.ok) { setBalance(0); setBalanceRaw('0'); return; }
            const data = await res.json();
            const rawStr = data.balance || '0';
            const raw = BigInt(rawStr);
            const human = Number(raw) / Math.pow(10, LILAPE_DECIMALS);
            setBalance(human);
            setBalanceRaw(rawStr);
        } catch {
            setBalance(0);
            setBalanceRaw('0');
        } finally {
            setLoading(false);
        }
    }, [walletAddress]);

    useEffect(() => {
        fetchBalance();
    }, [fetchBalance, refreshKey]);

    const refetch = useCallback(() => {
        setRefreshKey(k => k + 1);
    }, []);

    const formatted = balance === null ? null
        : balance >= 1e12 ? `${(balance / 1e12).toFixed(2)}T`
        : balance >= 1e9  ? `${(balance / 1e9).toFixed(2)}B`
        : balance >= 1e6  ? `${(balance / 1e6).toFixed(2)}M`
        : balance.toLocaleString();

    return { balance, balanceRaw, formatted, loading, refetch };
};
